import { GdprConsentString, CONFIG } from '@ecg-marktplaats/gdpr-consent-string';
import BANNER_CONFIG from '../constants/CONFIG';
import shouldResurfaceBannerForSourcepointExperiment from './shouldResurfaceBannerForSourcepointExperiment';

/**
 * This function allows us to forcefully resurface the banner
 * by invalidating TCStrings by date
 * @param gdprConsentString
 */
const shouldResurfaceBanner = (gdprConsentString?) => {
  if (!(gdprConsentString instanceof GdprConsentString)) {
    return false;
  }

  const tcModel: {
    vendorListVersion_: number;
    cmpId_: number;
  } & any = gdprConsentString?.getDecodedTCStringFromCookies();

  if (tcModel.vendorListVersion_ < BANNER_CONFIG.MINIMUM_GVL_VERSION) {
    /**
     * Check if we need to resurface the banner
     * We use tcModel.vendorListVersion_ here as we want to read the vendorVersionList
     * encoded into the TCString and not what our current GVL version is.
     */
    return true;
  }

  if (
    /**
     * tcModel is not an instance of TCModel if it does not have the property cmpId_
     */
    tcModel.cmpId_ !== CONFIG.CMP_ID
  ) {
    return true;
  }

  if (shouldResurfaceBannerForSourcepointExperiment()) {
    return true;
  }

  /**
   * TCStrings with date set before the `BANNER_CONFIG.EARLIEST_VALID_DATE`
   * will be ignored and the banner will be resurfaced
   */
  return tcModel.created.valueOf() <= BANNER_CONFIG.EARLIEST_VALID_DATE;
};

export default shouldResurfaceBanner;
